import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Costa David-Anton.`}</h1>
    <p>{`I am a game developer with web development background, experienced in Unity and Unreal Engine.
I am continuously striving for excellence and attaining new knowledge.
My goal is giving life to the worlds I envision while immersing my players and giving them the best possible experience.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      